import { selectActiveEntry, usePollingStore } from '@shared/store/use-polling-store'
import { useEffect, useState } from 'react'

const ONE_SECOND = 1_000

/** 폴링 시작 후 경과된 초(elapsed seconds)를 1초 간격으로 반환한다. */
export function useElapsedSeconds() {
  const startedAt = usePollingStore((s) => selectActiveEntry(s.entries)?.startedAt)
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (startedAt == null) {
      setElapsed(0)
      return
    }
    setElapsed(Math.floor((Date.now() - startedAt) / ONE_SECOND))
    const timer = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startedAt) / ONE_SECOND))
    }, ONE_SECOND)
    return () => {
      clearInterval(timer)
    }
  }, [startedAt])

  return elapsed
}
